"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UUPSUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _UUPSUpgradeable__factory.UUPSUpgradeable__factory;
  }
});

var _UUPSUpgradeable__factory = require("./UUPSUpgradeable__factory");